import React, { Component } from "react";
import { Button, Modal, Form, FormGroup, ControlLabel, FormControl } from "react-bootstrap";
import ReactTable from "react-table";
import "react-table/react-table.css";
import NumberFormat from "react-number-format";
import moment from "moment";
import Workbook from "react-excel-workbook-emptystring";

class ExcelList extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    const { title, configs } = this.props;
    const { data, file, pageSize, currentPage } = this.props.viewModel.state;

    return (
      <div>
        <Workbook
        filename={`${file}-${currentPage}-${pageSize}.xlsx`}
          element={
            <button
              type="button"
              className="link-button"
              href
              onClick={(e) => {
                e.preventDefault();
              }}
              style={{ margin: 5 }}>
              <i className="fa fa-file-excel-o"></i>Excel Completo
            </button>
          }>
          <Workbook.Sheet data={data} name={title}>
            {configs.map((config) => (
              <Workbook.Column key={config.value} label={config.label} value={config.value} width={config.width || 20} />
            ))}
          </Workbook.Sheet>
        </Workbook>
      </div>
    );
  }
}

export default ExcelList;
